var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59326 12.3267V5.55334C5.59326 5.28667 5.67326 5.02667 5.81993 4.80667L7.63993 2.1C7.92659 1.66667 8.63993 1.36 9.24659 1.58667C9.89993 1.80667 10.3333 2.54 10.1933 3.19334L9.8466 5.37334C9.81993 5.57334 9.87326 5.75334 9.98659 5.89334C10.0999 6.02 10.2666 6.1 10.4466 6.1H13.1866C13.7133 6.1 14.1666 6.31334 14.4333 6.68667C14.6866 7.04667 14.7333 7.51334 14.5666 7.98667L12.9266 12.98C12.7199 13.8067 11.8199 14.48 10.9266 14.48H8.32659C7.87993 14.48 7.25326 14.3267 6.96659 14.04L6.11326 13.38C5.78659 13.1333 5.59326 12.74 5.59326 12.3267Z",
    fill: "#FF7D38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4735 4.25336H2.78683C1.7535 4.25336 1.3335 4.65336 1.3335 5.64002V12.3467C1.3335 13.3334 1.7535 13.7334 2.78683 13.7334H3.4735C4.50683 13.7334 4.92683 13.3334 4.92683 12.3467V5.64002C4.92683 4.65336 4.50683 4.25336 3.4735 4.25336Z",
    fill: "#FF7D38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.f44b5b90c144f7ff25dc95d2a9b0b139.svg";
export { ForwardRef as ReactComponent };